module.exports = __webpack_public_path__ + "static/img/seta_dark.923ab569.svg";